
export const toggleLayerState = (layerId) => {
    return {
        type: 'TOGGLE_LAYER_STATE',
        payload: {layerId}
    }
};

export const changeMapZoom = (zoom) => {
    return {
        type: 'CHANGE_ZOOM',
        payload: zoom
    }
}

export const updateSld = (layerId, sldBody, styleData) => {
    return {
        type: 'UPDATE_SLD',
        payload: {layerId, sldBody, styleData}
    }
}

export const changeColorRamp = (colorRamp) => {
    return {
        type: "CHANGE_COLORRAMP",
        payload: colorRamp
    }
}

export const setActiveField = (field) => {
    return {
        type: "SET_ACTIVE_FIELD",
        payload: field
    }
}

export const updateBms = (bmIds) => {
    return {
        type: "UPDATE_BMS",
        payload: bmIds
    }
}